import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { AuthService } from "../../services/auth.service";
import { first } from 'rxjs/operators';
import * as SockJs from 'sockjs-client';
import { environment } from "../../../environments/environment";
import Speech from 'speak-tts';
const Stomp = require('stompjs');

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  @ViewChild('togglenavbar') navbarToggler: ElementRef<HTMLElement>;
  navbarOpen = false;
  firstname: string = "";
  lastname: string = "";
  firstTime: boolean = false;
  user: any = {};
  private stompClient: any = null;
  classes: string[] = [];
  messages: any[] = [];
  speech: any;
  speechData: any;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    // this.firstname = localStorage.getItem("firstname");
    // this.lastname = localStorage.getItem("lastname");
    // if (
    //   localStorage.getItem("isloggedIn") === "true" &&
    //   sessionStorage.getItem("UserLogin") === "Yes"
    // ) {
    //   //this.router.navigate(["/waitinglist"]);
    //   //this.router.navigate(["/business/list/1"]);
    // } else {
    //   this.auth.logoutUser();
    //   this.router.navigate(["/login"]);
    // }
  }

  ngOnInit() {
    this.firstTime = true;
    this.user = JSON.parse(localStorage.getItem("user"));
    
    if (!localStorage.getItem("navBarOpen") || localStorage.getItem("navBarOpen") == "true") {
      localStorage.setItem("navBarOpen", "false");
      
      this.navbarToggler?.nativeElement?.click();
      this.firstTime = false;
    }

    this.connectWebSocket();

    this.speech = new Speech() // will throw an exception if not browser supported
    if (this.speech.hasBrowserSupport()) { // returns a boolean
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        // The "data" object contains the list of available voices and the voice synthesis params
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
        console.error("An error occured while initializing : ", e)
      })
    }
  }

  logout() {
    this.auth.logoutUser();
    this.router.navigate(["/login"]);
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
    if (!this.firstTime) {
      this.navbarOpen = !this.navbarOpen;
      localStorage.setItem("navBarOpen", "" + this.navbarOpen);
    }
  }

  private connectWebSocket(): void {
    let ref = this;
    let socket = new SockJs(environment.apiURL + 'secured/chat/location-verification?access_token=' + localStorage.getItem("access_token"));
    ref.stompClient = Stomp.over(socket);

    ref.stompClient.connect({}, (frame) => {
      // Subscribe and open modal once export is ready
      ref.stompClient.subscribe('/secured/history/location-verification/' + this.user.scac, (message) => {

        // let loadInfo = JSON.parse(message.body);

        // localStorage.setItem("mapComparisonObject",message.body);

        // let src = '../../../assets/sounds/verification_alert.mp3';
        // let audio = new Audio(src);
        // this.classes.push("bell");
        // this.messages.push(loadInfo);
        // audio.play();

        // if (!loadInfo.body.timeTracker.isInGeoFence || loadInfo.body.timeTracker.isInGeoFence == "false") {
        //   let alertMessage = loadInfo.body.timeTracker.driver + " Suggested that he is at location for Route [" + loadInfo.body.driverRouteSheetDTO.routeId + "], BILL OF LADING [" + loadInfo.body.billofladingDTO.billOfLadingId + "] but according to GPS he is not, please contact if necessary";
        //   this.speech.speak({
        //     text: alertMessage,
        //   }).then(() => {
        //   }).catch(e => {
        //     console.error("An error occurred :", e)
        //   })

        // }
        
        // setTimeout(() => { this.classes = [] }, 4000);

      });
    });

  }
}
